import { TransactionIdAndType, LinkedTransactionsMap, EftFundingTransactionResponse, TransactionType } from 'vopay';
import { useEffect, FC, useState } from 'react';
import { useParams } from 'react-router-dom';
import useFetchEFTFundTransaction from '../../hooks/useApi/useFetchEFTFundTransaction';
import useAccountBearer from '@/hooks/useApi/useAccountBearer';
import EftFundingTransactionInfo from './EftFundingTransactionInfo';
import LinkedTransactionInfo from './LinkedTransactionInfo';

const EftFundingTransactionContainer: FC<TransactionIdAndType> = ({
  TransactionID,
  Type,
}: TransactionIdAndType) => {
  const { accountId } = useParams<{ accountId: string }>();
  const token = useAccountBearer(accountId);
  const [isDataFeched, setIsDataFeched] = useState(false);
  const [subTransactions, setSubTransactions] = useState<LinkedTransactionsMap>();

  const [eftFundTransaction, getEftFundTransaction, resetTransactionsId] = useFetchEFTFundTransaction({
    bearer: token,
  });

  const [currentTransactionId, setCurrentTransactionId] = useState<string>();
  const [transaction, setTransaction] = useState<EftFundingTransactionResponse>();

  useEffect(() => {
    if (!token) return;

    if (Type === TransactionType.EFT_FUNDING) {
      getEftFundTransaction(TransactionID);
    }

    setIsDataFeched(true);
  }, [currentTransactionId, token]);

  useEffect(() => {
    if (isDataFeched && Object.values(eftFundTransaction).length > 0 && eftFundTransaction.SubTransactions) {
      const subTransactionsList: LinkedTransactionsMap = Object.values(eftFundTransaction.SubTransactions);

      setSubTransactions(subTransactionsList);
    }
  }, [eftFundTransaction]);

  useEffect(() => {
    if (eftFundTransaction) {
      setTransaction(eftFundTransaction);
    }
  }, [eftFundTransaction]);

  if (currentTransactionId !== TransactionID) {
    setCurrentTransactionId(TransactionID);
    resetTransactionsId();
  }

  return (
    <div>
      {transaction && <EftFundingTransactionInfo transaction={transaction} />}
      {subTransactions && <LinkedTransactionInfo LinkedTransactions={subTransactions} />}
    </div>
  );
};

export default EftFundingTransactionContainer;
